import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp, faInstagram } from "@fortawesome/free-brands-svg-icons";
import {
  ContactColumn,
  ContactParagraph,
  CarLogo,
} from "../../../components/ContactSection";

const MapSectionContainer = styled.div`
  height: 100%;
  width: 50%;
  background-color: var(--black);
  @media (max-width: 992px) {
    width: 40%;
    display: flex;
    flex-direction: column;
  }
  @media screen and (max-width: 675px) {
    width: 100%;
  }
`;

const MapContainer = styled.div`
  width: 100%;
  height: 70%;

  @media (max-width: 992px) {
    height: 300px;
  }
  @media screen and (max-width: 675px) {
    order: 2;
  }
`;

const Map = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0px;

  @media screen and (max-width: 675px) {
    order: 2;
  }
`;

const ContactInfoContainer = styled.div`
  display: flex;
  gap: 100px;
  justify-content: center;
  align-items: center;
  height: 30%;

  @media (max-width: 1185px) {
    gap: 20px;
  }
  @media (max-width: 992px) {
    height: unset;
    gap: 30px;
    padding: 30px 0px;
    flex-direction: column;
  }
  @media screen and (max-width: 675px) {
    gap: 40px;
    padding: 40px 0px;
    order: 1;
  }
`;

const Column = styled(ContactColumn)`
  height: 100%;
  justify-content: center;
  padding-top: 20px;
  @media (max-width: 992px) {
    padding: 0px 0px;
  }
`;

const AlternateCarLogo = styled(CarLogo)`
  height: 75px;
  margin-top: -3px;
  @media (max-width: 1400px) {
    width: unset;
    height: 50px;
    margin-top: 0px;
  }
  @media (max-width: 576px) {
    max-width: 300px;
  }
`;

const ContactMap = () => {
  return (
    <MapSectionContainer>
      <MapContainer>
        <Map
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.560205584047!2d-58.51419478255616!3d-34.665808199999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcc8e323bd5e9f%3A0x451bfdcdcd0fc0aa!2sAv.%20Gral.%20Paz%2013124%2C%20C1440%20CABA!5e0!3m2!1ses!2sar!4v1664727745430!5m2!1ses!2sar"
          title="Real Cars"
          allowfullScreen="true"
          loading="lazy"
        />
      </MapContainer>
      <ContactInfoContainer>
        <Column>
          <ContactParagraph>
            <FontAwesomeIcon icon={faWhatsapp} color={"#32cd32"} />
            +54 9 11 5850-3232{" "}
          </ContactParagraph>
          <ContactParagraph>
            <FontAwesomeIcon icon={faWhatsapp} color={"#32cd32"} />
            +54 9 11 3071-0101
          </ContactParagraph>

          <ContactParagraph>
            <FontAwesomeIcon icon={faInstagram} color={"#E1306C"} />{" "}
            realcarsalquiler
          </ContactParagraph>
          <ContactParagraph>
            <FontAwesomeIcon icon={faEnvelope} /> contactorealcars@gmail.com
          </ContactParagraph>
        </Column>

        <AlternateCarLogo src="/images/auto.png" />
      </ContactInfoContainer>
    </MapSectionContainer>
  );
};

export default ContactMap;
